import React, { use, useState } from "react";
import {
  TrendingUp,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
  Info,
  Star,
  Rocket,
  HelpCircle,
} from "lucide-react";
import { showToast } from "../../../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
//import './Subscription.scss';
import { useSelector } from "react-redux";
import moment from "moment/moment";
import Loader from "../../../../Loader/Loader"; // adjust the path
import { hitGetCreditHistoryProfessionalApi } from "../../../../../Redux/Professional/GetCreditHistoryProfessionalSlice";
import CreditsUsed from "../../../../../assets/img/Credits Used.svg";
import DaysPeriod from "../../../../../assets/img/Days Period.svg";
import HowCreditsWork from "../../../../../assets/img/How Credits Work.svg";
import ReadyToGo from "../../../../../assets/img/Ready to Go message noti.svg";
import cil_wallet from "../../../../../assets/img/cil_wallet.svg";
import creditIcon from "../../../../../assets/img/Credits setting icon.svg";
import RecentActivity from "../../../../../assets/img/Recent Activity red.svg";
import { timeAgo } from "../../../../../Helper/CommonFunctions";

const NewCredit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState(25);
  const [creditData, setCreditData] = useState([]);
  const [activitiesData, setActivitiesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activityCounts, setActivityCounts] = useState(0);
  const [totalDays, setTotalDays] = useState(0);
  const [totalCreditUsed, setTotalCreditUsed] = useState(0);
  const [activeFilter, setActiveFilter] = useState("all"); // default active → All Time

  const creditStats = {
    available: 75,
    earned: 450,
    spent: 10,
  };

  const recentActivity = [
    {
      id: 1,
      action: "Job Posted with camera",
      date: "Jun 12, 2023",
      credits: -5,
      type: "spent",
    },
    {
      id: 2,
      action: "Job Posted with camera",
      date: "Jun 10, 2023",
      credits: -5,
      type: "spent",
    },
    {
      id: 3,
      action: "Credits purchased",
      date: "Jun 01, 2023",
      credits: +100,
      type: "earned",
    },
    {
      id: 4,
      action: "Job Posted with camera",
      date: "May 28, 2023",
      credits: -10,
      type: "spent",
    },
  ];

  const creditPlans = [
    { credits: 10, price: 10, popular: false },
    { credits: 25, price: 25, popular: true },
    { credits: 50, price: 50, popular: false },
    { credits: 100, price: 100, popular: false },
  ];

  const earnCreditsWays = [
    {
      label: "Simple Pricing",
      description: "1 credit = $1.00 with no hidden fees",
      completed: true,
    },
    {
      label: "Never Expire",
      description: "Credits remain active as long as your account is active",
      completed: false,
    },
    {
      label: "Instant Delivery",
      description: "Credits remain active as long as your account is active",
      completed: false,
    },
    {
      label: "Secure Processing",
      description: "Bank-level security with PCI compliance",
      completed: false,
    },
  ];

  const handleDaysFilter = (days) => {
    setActiveFilter(days);
    dispatch(hitGetCreditHistoryProfessionalApi({ filterDays: days })).then(
      (response) => {
        if (response.payload && response.payload.data) {
          setLoading(false);
          setCreditData(response.payload.creditData);
          setTotalCreditUsed(response.payload.creditData.totalCreditUsed);
          const givenDate = moment(response.payload.creditData.createdAt);
          const today = moment();
          setTotalDays(today.diff(givenDate, "days"));
          setActivityCounts(response.payload.count);
          setActivitiesData(response.payload.data);
        }
      }
    );
  };

  useEffect(() => {
    dispatch(hitGetCreditHistoryProfessionalApi()).then((response) => {
      //console.log("Credit History Response:", response);
      if (response.payload && response.payload.data) {
        setLoading(false);
        setCreditData(response.payload.creditData);
        setTotalCreditUsed(response.payload.creditData.totalCreditUsed);
        const givenDate = moment(response.payload.creditData.createdAt);
        const today = moment();
        setTotalDays(today.diff(givenDate, "days"));
        setActivityCounts(response.payload.count);
        setActivitiesData(response.payload.data);
      }
    });
  }, [dispatch]);


  const creditOptions = [
    {
      category: "Job Posting with Measurement",
      description: "Free to post + Credits used when bid is placed",
      options: [
        {
          label: "Ready to go on camera",
          credits: 5,
          icon: <img src={ReadyToGo} alt="Ready to Go message noti" />,
        },
      ],
    },
    {
      category: "Job Posting without Measurement",
      description: "Free to post + Credits used when bid is placed",
      options: [
        {
          label: "Ready to go",
          credits: 10,
          icon: <img src={ReadyToGo} alt="Ready to Go message noti" />,
        },
      ],
    },
  ];

  return (
    <div className="credits-dashboard">
      <div className="dashboard-container">
        <div className="stats-card">
          <div className="main-stat">
            <div className="stat-label">Available Credits</div>
            <div className="stat-value-large">
              {creditData.totalCreditPoints}
            </div>
            <div className="stat-label">
              = ${creditData.totalCreditPoints}.00 USD
            </div>
          </div>
        </div>

        <div className="progress-bar-container">
          <div className="progress-labels">
            <button
              className={`progress-label-item1 ${
                activeFilter === "7" ? "active" : ""
              }`}
              style={{
                backgroundColor:
                  activeFilter === "7" ? "#3b82f6" : "transparent",
                color: activeFilter === "7" ? "#fff" : "#000",
                border: activeFilter === "7" ? "1px solid #3b82f6" : "none",
              }}
              onClick={() => handleDaysFilter("7")}
            >
              7 Days
            </button>
            <button
              className={`progress-label-item1 ${
                activeFilter === "30" ? "active" : ""
              }`}
              style={{
                backgroundColor:
                  activeFilter === "30" ? "#3b82f6" : "transparent",
                color: activeFilter === "30" ? "#fff" : "#000",
                border: activeFilter === "30" ? "1px solid #3b82f6" : "none",
              }}
              onClick={() => handleDaysFilter("30")}
            >
              30 Days
            </button>
            <button
              className={`progress-label-item1 ${
                activeFilter === "all" ? "active" : ""
              }`}
              style={{
                backgroundColor:
                  activeFilter === "all" ? "#3b82f6" : "transparent",
                color: activeFilter === "all" ? "#fff" : "#000",
                border: activeFilter === "all" ? "1px solid #3b82f6" : "none",
              }}
              onClick={() => handleDaysFilter("all")}
            >
              All Time
            </button>
          </div>
        </div>

        <div className="stats-grid">
          <div className="stat-item">
            <img src={CreditsUsed} alt="Credits Used" className="mb-2" />
            <div className="stat-value">{totalCreditUsed || 0}</div>
            <div className="stat-label-small">Credits Used</div>
          </div>
          <div className="stat-item">
            <img src={DaysPeriod} alt="Days Period" className="mb-2" />
            <div className="stat-value">{totalDays}</div>
            <div className="stat-label-small">Days Period</div>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="activity-section">
          <div className="section-header">
            <h2 className="section-title">Recent Credit Activity</h2>
            {/* <a href="#" className="view-all-link">
              View All
            </a> */}
          </div>

          <div className="activity-list">
            {activitiesData.map((activity) => (
              <div key={activity._id} className="activity-item">
                <div className="activity-icon">
                  <div className={`icon-circle ${activity.type}`}>
                    <img src={RecentActivity} alt="Recent Activity" size={16} />
                  </div>
                </div>
                <div className="activity-content">
                  <div className="activity-title">{activity.activity === "bidPlace"? "Bid Placed" : activity.activity === "addCreditPoints" ? "Credit Points Added" : activity.activity}</div>
                  <div className="activity-date">{timeAgo(activity.createdAt)}</div>
                </div>
                <div className={`activity-credits ${activity.type}`}>
                  {activity.type === 1 ? "+" : "-"}
                  {activity.points}
                </div>
              </div>
            ))}
          </div>

          {/* <div className="pagination">
            <button className="pagination-btn">
              <ChevronLeft size={16} />
              Previous
            </button>
            <div className="pagination-numbers">
              <button className="pagination-number active">1</button>
              <button className="pagination-number">2</button>
              <button className="pagination-number">3</button>
            </div>
            <button className="pagination-btn">
              Next
              <ChevronRight size={16} />
            </button>
          </div> */}
        </div>

        {/* Info Banner */}
        <div className="info-banner">
          <div className="info-icon">
            <img src={creditIcon} alt="Credits icon" />
          </div>
          <div className="info-content">
            <strong>Credits</strong>
            <p>
              Credits power your bidding on SimpleRenovate. Each credit equals
              $1.00 with no hidden fees.
            </p>
          </div>
        </div>

        {/* Earn Free Credits */}
        <div className="earn-section">
          <h3 className="earn-title">How Credits Work</h3>

          <div className="earn-list">
            {earnCreditsWays.map((way, index) => (
              <div key={index} className="earn-item">
                {/* {way.completed && "✓"} */}
                <img
                  src={HowCreditsWork}
                  alt="How Credits Work"
                  className="mt-1"
                />
                <div className="earn-content">
                  <div className="earn-label">{way.label}</div>
                  <div className="earn-description">{way.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="credit-usage-container">
          <div className="credit-usage-header">
            <h2 className="credit-usage-title">CREDIT USAGE</h2>
            <button className="help-button">
              <HelpCircle size={20} />
            </button>
          </div>
          <div className="credit-sections">
            {creditOptions.map((section, sectionIndex) => (
              <div key={sectionIndex} className="credit-section">
                <div className="section-header">
                  <h3 className="section-title mb-0">{section.category}</h3>
                </div>
                <p className="section-description">{section.description}</p>
                <div className="credit-options-list">
                  {section.options.map((option, optionIndex) => (
                    <div key={optionIndex} className="credit-option-item">
                      <div className="option-left">
                        <span className="option-icon">{option.icon}</span>
                        <span className="option-label">{option.label}</span>
                      </div>
                      <div className="option-credits">
                        <span className="credits-amount">
                          {option.credits} credits
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Buy Credits Section */}
        <div className="buy-section">
          <h2 className="buy-title">Available Packagess</h2>

          <div className="plans-grid">
            {creditPlans.map((plan) => (
              <div
                key={plan.credits}
                className={`plan-card ${
                  selectedPlan === plan.credits ? "selected" : ""
                } ${plan.popular ? "popular" : ""}`}
                onClick={() => setSelectedPlan(plan.credits)}
              >
                {plan.popular && (
                  <div className="popular-badge">
                    <Star size={12} fill="currentColor" />
                    POPULAR
                  </div>
                )}
                <div className="plan-credits">{plan.credits}</div>
                <div className="stat-label-small">Credits</div>
                <div className="plan-price">${plan.price}</div>
              </div>
            ))}
          </div>

          {/* <p className="credits-info">
            Or enter custom amount (minimum 5 credits)
          </p>
          <div className="promo-section mt-3">
            <input
              type="number"
              placeholder="Enter credit amount"
              className="custom-credits-input"
            />
          </div> */}

          {/* <div className="expiry-info">Credits purchased expire in 1 year</div> */}

          <div className="promo-section">
            <div className="promo-text">
              <strong>You're purchasing 25 credits for $25.00</strong>
            </div>
          </div>

          <div className="promo-section-btn">
            <button
              className="btn-buy-credits"
              onClick={() => navigate("/professional/buy-credits")}
            >
              <img src={cil_wallet} alt="cil_wallet" />
              Buy Credits
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewCredit;
